import Route from '@ember/routing/route';
import { type Registry as Services, service } from '@ember/service';
import { getHostDomain } from 'frontend-utils/utils/domain-checks';
import { openUrl } from 'frontend-utils/utils/url/open-url';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import type { Transition } from 'lumen/services/transition';

export default class HotelChannelManagerRoute extends Route {
  @service declare access: Services['access'];
  @service('hotel-and-market')
  declare hotelAndMarketServiceWithHotel: HotelAndMarketServiceWithHotel;
  @service declare router: Services['router'];
  @service declare transition: Services['transition'];

  handleRedirect = (): void => {
    const { id } = this.hotelAndMarketServiceWithHotel.hotel;

    openUrl(
      `${getHostDomain()}/apigateway/v1/app/channel-management/channelmanager/outgoing?subscription_id=${id}`,
      true,
    );
  };

  beforeModel(transition: Transition): void {
    if (!this.access.hasChannelManagerTab) {
      if (this.access.hasPricingAssistantTab) {
        this.router.transitionTo('hotel.pricing-manager');
      } else {
        this.transition.redirectToEnabledTab(transition);
      }
    } else if (!this.access.user.hasMultipleSubscriptions) {
      // Only trigger the redirect automatically if the user only has one hotel (avoid automatic re-direct loop (SH-44302)
      this.handleRedirect();
    }
  }

  model(): { handleRedirect: () => void } {
    return { handleRedirect: this.handleRedirect };
  }
}
